import React from "react";
import "./home.css";
import Featured from "../components/featured/Featured";
import PropertyList from "../components/propertyList/PropertyList";
import FeaturedHomes from "../components/featuredHomes/FeaturedHomes";
import Mail from "../components/mail/Mail";
import Footer from "../components/footer/Footer";

function Home() {
  return (
    <div>
      <div className="homeContainer">
        <Featured />
      <h1 className="homeTitle">Browse by property type</h1>
        <PropertyList />
        <h1 className="homeTitle">Homes guests love</h1>
        <FeaturedHomes />
        <Mail />
        <Footer />
      </div>
    </div>
  );
}

export default Home;
